import completed from "../images/icon-complete.svg";
export default function Thankyou() {
  return (
    <div className="thankyou">
      <img src={completed} alt=""></img>
      <h1>THANK YOU!</h1>
      <h3>We’ve added your card details</h3>
    </div>
  );
}
